export enum Locales {
    NL = 0,
    EN = 1,
}

export enum LocalesStrings {
    NL = 'nl',
    EN = 'en',
}

export type LocaleText = {
    nl: string
    en?: string
    [key: string]: string
}
